import { Cliente } from '../types';

export interface ClientColor {
  primary: string;
  background: string;
}

export interface ClientColorMap {
  get(clientId: string): ClientColor;
  getForCliente(cliente: Cliente): ClientColor;
}

export const createClientColorMap = (clienti: Cliente[]): ClientColorMap => {
  const customColors: Record<string, ClientColor> = {
    '7sunday': { primary: '#ec4899', background: 'rgba(236, 72, 153, 0.18)' }, // rosa
    'belotti costruzioni': { primary: '#dc2626', background: 'rgba(220, 38, 38, 0.18)' }, // rosso
    'avvocato lattanzio': { primary: '#0ea5e9', background: 'rgba(14, 165, 233, 0.18)' }, // azzurro
    'studio dentistico lazzari': { primary: '#1e3a8a', background: 'rgba(30, 58, 138, 0.18)' }, // blu navy
    'dmo noleggi': { primary: '#8b5cf6', background: 'rgba(139, 92, 246, 0.18)' }, // viola
    'arippol estates': { primary: '#16a34a', background: 'rgba(22, 163, 74, 0.18)' }, // verde
    'bgates': { primary: '#3b82f6', background: 'rgba(59, 130, 246, 0.18)' }, // azzurro diverso
    'dmo': { primary: '#8b5cf6', background: 'rgba(139, 92, 246, 0.18)' }, // viola
    'next step': { primary: '#d946ef', background: 'rgba(217, 70, 239, 0.18)' }, // fucsia
  };

  const fallbackPalette: ClientColor[] = [
    { primary: '#7c3aed', background: 'rgba(124, 58, 237, 0.18)' },
    { primary: '#f97316', background: 'rgba(249, 115, 22, 0.2)' },
    { primary: '#14b8a6', background: 'rgba(20, 184, 166, 0.18)' },
    { primary: '#f59e0b', background: 'rgba(245, 158, 11, 0.2)' },
    { primary: '#6366f1', background: 'rgba(99, 102, 241, 0.18)' },
  ];

  const map = new Map<string, ClientColor>();
  const defaultColor: ClientColor = { primary: '#4b5563', background: 'rgba(75, 85, 99, 0.18)' };

  // Assegna colori personalizzati
  clienti.forEach(cliente => {
    const normalizedName = cliente.nomeAzienda.trim().toLowerCase();
    const specific = customColors[normalizedName];
    if (specific) {
      map.set(cliente.id, specific);
    }
  });

  // Assegna colori fallback a clienti senza colori personalizzati
  let fallbackIndex = 0;
  clienti.forEach(cliente => {
    if (!map.has(cliente.id)) {
      const paletteEntry = fallbackPalette[fallbackIndex % fallbackPalette.length];
      map.set(cliente.id, paletteEntry);
      fallbackIndex += 1;
    }
  });

  return {
    get: (clientId: string) => {
      return map.get(clientId) || defaultColor;
    },
    getForCliente: (cliente: Cliente) => {
      return map.get(cliente.id) || defaultColor;
    }
  };
};

export const getClientColorStyles = (colors: ClientColor) => ({
  backgroundColor: colors.background,
  color: colors.primary,
  borderColor: colors.primary
});